import {
    LayoutEntryGutterCommentsState, LayoutEntryGutterMetricsState,
    LayoutState
} from '../_reducers/layout';

type LocalState = {
    layout: LayoutState;
};

export const getLayoutEntryGutterComments = ({layout}: LocalState): LayoutEntryGutterCommentsState => {
    return layout.entryGutter.comments;
}

export const getLayoutEntryGutterMetrics = ({layout}: LocalState): LayoutEntryGutterMetricsState => {
    return layout.entryGutter.metrics;
}